import Vue from 'vue'
import Router from 'vue-router'
import Portal from '@/components/Portal'
import Callback from '@/components/Callback'
import Logout from '@/components/Logout'
import { requireAuth } from '@/auth/auth';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Portal',
      component: Portal,
      beforeEnter: requireAuth
    },
    {
        path: '/callback',
        name: 'Callback',
        component: Callback
    },
    {
        path: '/logout',
        name: 'Logout',
        component: Logout
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js